import {
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import {
  STATUS_SOLICITACAO_LABEL,
  StatusSolicitacaoOrcamento,
} from "interfaces/orcamento";
import { ORCAMENTO_ACCENT, solicitacoesToolbarSx } from "./orcamento-solicitacoes.theme";

const STATUS_OPTIONS: { value: "" | StatusSolicitacaoOrcamento; label: string }[] = [
  { value: "", label: "Todos" },
  { value: "NOVO", label: STATUS_SOLICITACAO_LABEL.NOVO },
  { value: "EM_ANALISE", label: "Em análise" },
  { value: "AGUARDANDO_CLIENTE", label: "Aguard. cliente" },
  { value: "PROPOSTA_ENVIADA", label: "Proposta enviada" },
  { value: "APROVADO", label: STATUS_SOLICITACAO_LABEL.APROVADO },
  { value: "RECUSADO", label: STATUS_SOLICITACAO_LABEL.RECUSADO },
  { value: "CANCELADO", label: STATUS_SOLICITACAO_LABEL.CANCELADO },
];

type Props = {
  busca: string;
  statusFilter: "" | StatusSolicitacaoOrcamento;
  totalExibindo: number;
  onBuscaChange: (value: string) => void;
  onStatusChange: (status: "" | StatusSolicitacaoOrcamento) => void;
};

export default function SolicitacoesFilters({
  busca,
  statusFilter,
  totalExibindo,
  onBuscaChange,
  onStatusChange,
}: Props) {
  return (
    <MDBox sx={solicitacoesToolbarSx}>
      <Stack spacing={2}>
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
          <InboxOutlinedIcon sx={{ color: ORCAMENTO_ACCENT }} />
          <MDTypography variant="button" fontWeight="medium" color="text">
            {totalExibindo > 0
              ? `${totalExibindo} solicitação${totalExibindo === 1 ? "" : "ões"} no filtro atual`
              : "Nenhuma solicitação no filtro atual"}
          </MDTypography>
        </Stack>

        <FormControl variant="outlined" size="small" fullWidth>
          <InputLabel htmlFor="solicitacoes-search">Buscar solicitação</InputLabel>
          <OutlinedInput
            id="solicitacoes-search"
            value={busca}
            onChange={(e) => onBuscaChange(e.target.value)}
            label="Buscar solicitação"
            placeholder="Código, nome, e-mail, cidade…"
            endAdornment={
              <InputAdornment position="end">
                <Search fontSize="small" />
              </InputAdornment>
            }
            sx={{ bgcolor: "background.paper", borderRadius: 1.5 }}
          />
        </FormControl>

        <ToggleButtonGroup
          exclusive
          size="small"
          value={statusFilter}
          onChange={(_, next: "" | StatusSolicitacaoOrcamento | null) => {
            if (next === null) return;
            onStatusChange(next);
          }}
          sx={{
            flexWrap: "wrap",
            "& .MuiToggleButton-root": {
              px: 1.25,
              py: 0.75,
              textTransform: "none",
              fontSize: "0.8125rem",
              "&.Mui-selected": {
                bgcolor: "rgba(249, 96, 48, 0.1)",
                borderColor: ORCAMENTO_ACCENT,
                color: ORCAMENTO_ACCENT,
                fontWeight: 600,
              },
            },
          }}
        >
          {STATUS_OPTIONS.map((opt) => (
            <ToggleButton key={opt.value || "all"} value={opt.value}>
              {opt.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Stack>
    </MDBox>
  );
}
